import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import InputSearch from "@/components/ui/input/InputSearch.vue";
import getUserRole from "@/helpers/getUserRole";
import isReportsRoute from "@/helpers/analytics/isReportsRoute";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit }) {
  __expose();

const props = __props;

const { isLandownerRole } = getUserRole();




function toggleBurger() {
  emit("update:modelValue", !props.modelValue);
}

const search = ref("");

const __returned__ = { isLandownerRole, emit, props, toggleBurger, search, ref, InputSearch, get getUserRole() { return getUserRole }, get isReportsRoute() { return isReportsRoute } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})